import React from "react";
import MyAccountInfo from "../../components/myaccountinfo/myaccountinfo";

export default function GeneralSettings(){
    return(
        <>
            <MyAccountInfo/>
        </>
    );
}